import * as React from 'react';
/**
 *
 * Original name: present
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A315
 *
 */
export const PresentPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M58 12H6v4h3v26a6.007 6.007 0 0 0 6 6h6.894l-3.636 8h4.393l3.636-8h11.426l3.636 8h4.393l-3.636-8H49a6.007 6.007 0 0 0 6-6V16h3v-4Zm-7 30a2 2 0 0 1-2 2H15a2 2 0 0 1-2-2V16h38v26Z", fill: "currentColor" }),
    React.createElement("path", { d: "M26 21v18l15-9-15-9Z", fill: "currentColor" })));
